(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elabell-footer"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('elabell-footer')){
 customElements.define('elabell-footer',class extends HTMLElement{
  connectedCallback(){
   this.abort=new AbortController();const signal=this.abort.signal,media=matchMedia('(max-width:749px)');
   const resize=()=>this.querySelectorAll('.eb-footer-nav').forEach(details=>{details.open=!media.matches;details.querySelector('summary').tabIndex=media.matches?0:-1;});
   resize();media.addEventListener('change',resize,{signal});
   this.observer=new IntersectionObserver(entries=>document.documentElement.classList.toggle('eb-footer-in-view',entries.some(entry=>entry.isIntersecting)));
   this.observer.observe(this);
  }
  disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();document.documentElement.classList.remove('eb-footer-in-view');}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elabell-product-extras"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('elabell-complements')){
 customElements.define('elabell-complements',class extends HTMLElement{
  connectedCallback(){
   this.abort=new AbortController();const signal=this.abort.signal;
   const form=this.querySelector('form'),button=form.querySelector('button[type="submit"]'),total=form.querySelector('[data-extra-total]'),status=form.querySelector('[data-extra-status]');
   if(!button)return;
   const cards=[...form.querySelectorAll('.eb-complement-card')],extras=cards.filter(card=>!card.classList.contains('eb-main-choice'));
   const modes=[...form.querySelectorAll('[data-offer-mode]')],original=form.querySelector('[data-extra-original]');
   const money=value=>new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).format(value/100);
   const quantity=form.querySelector('[data-main-quantity]');
   const selection=()=>cards.filter(card=>card.querySelector('[data-select-extra]').checked).map(card=>{const select=card.querySelector('[data-variant]'),main=card.classList.contains('eb-main-choice');return{id:Number(select.value),quantity:main?Number(quantity.value):1,price:Number(select.selectedOptions[0].dataset.price)};});
   const update=()=>{
    const items=selection(),units=items.reduce((sum,item)=>sum+item.quantity,0),sum=items.reduce((value,item)=>value+item.price*item.quantity,0);
    const rate=this.dataset.discountEnabled==='true'?(units>=3?15:units>=2?10:0):0;
    const saving=Math.floor(sum*rate/100);
    total.textContent=money(sum-saving);original.hidden=saving===0;original.textContent=money(sum);
    const savings=form.querySelector('[data-extra-saving]');if(savings)savings.textContent=saving?rate+'% de desconto: você economiza '+money(saving)+'.':'';
    modes.forEach(mode=>mode.checked=Number(mode.value)===(units>=3?3:units>=2?2:1));
    button.disabled=items.length===0||!form.checkValidity();button.textContent=units>1?'Adicionar '+units+' unidades à sacola':'Adicionar peça à sacola';status.textContent='';
   };
   const setMode=()=>{
    const units=Number(modes.find(input=>input.checked)?.value||1);
    extras.forEach((card,index)=>{card.hidden=units===1;card.querySelector('[data-select-extra]').checked=index<units-1;});
    quantity.value=String(Math.max(1,units-extras.filter(card=>card.querySelector('[data-select-extra]').checked).length));
    update();
   };
   form.addEventListener('change',event=>{
    if(event.target.matches('[data-offer-mode]')){setMode();return;}
    update();
   },{signal});
   quantity.addEventListener('input',update,{signal});setMode();
   form.addEventListener('submit',async event=>{
    event.preventDefault();const items=selection().map(({id,quantity})=>({id,quantity}));if(!items.length)return;
    button.disabled=true;button.setAttribute('aria-busy','true');status.textContent='Adicionando sua seleção…';
    try{
     const response=await fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
     const result=await response.json();if(!response.ok)throw Error(typeof result.description==='string'?result.description:'Não foi possível adicionar a seleção. Confira a disponibilidade das opções.');
     window.location.assign(window.Shopify.routes.root+'cart');
    }catch(error){status.textContent=error.message||'Não foi possível adicionar. Tente novamente.';button.disabled=false;}
    finally{button.removeAttribute('aria-busy');}
   },{signal});
  }
  disconnectedCallback(){this.abort?.abort();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elabella-home"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('elabella-benefits')){
 customElements.define('elabella-benefits',class extends HTMLElement{
  connectedCallback(){
   this.abort=new AbortController();const signal=this.abort.signal;
   const viewport=this.querySelector('.eb-benefit-window'),items=[...this.querySelectorAll('.eb-benefit-item')],counter=this.querySelector('.eb-benefit-count');
   const update=()=>{const index=Math.round(viewport.scrollLeft/viewport.clientWidth);counter.textContent=String(index+1).padStart(2,'0')+' / '+String(items.length).padStart(2,'0');};
   this.querySelectorAll('[data-direction]').forEach(button=>button.addEventListener('click',()=>{const current=Math.round(viewport.scrollLeft/viewport.clientWidth);const next=(current+Number(button.dataset.direction)+items.length)%items.length;viewport.scrollTo({left:next*viewport.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});},{signal}));
   viewport.addEventListener('scroll',update,{signal,passive:true});
   viewport.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();this.querySelector('[data-direction="'+(event.key==='ArrowRight'?1:-1)+'"]').click();}},{signal});
  }
  disconnectedCallback(){this.abort?.abort();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elabella-mobile-banners"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('elabella-mobile-banner')) {
 customElements.define('elabella-mobile-banner', class extends HTMLElement {
  connectedCallback() {
   this.abort = new AbortController(); const signal = this.abort.signal;
   this.track = this.querySelector('.eb-mobile-track');
   this.slides = [...this.querySelectorAll('.eb-mobile-slide')];
   this.dots = [...this.querySelectorAll('[data-slide]')];
   this.pause = this.querySelector('.eb-mobile-pause'); this.index = 0; this.stopped = false;
   this.media = matchMedia('(max-width:749px)'); this.reduced = matchMedia('(prefers-reduced-motion:reduce)');
   this.visible = false; this.focused = false; this.pointer = null;
   const schedule = (delay = 2000) => {
    clearTimeout(this.timer);
    if (this.slides.length < 2 || this.stopped || this.focused || !this.visible || !this.media.matches || this.reduced.matches || document.hidden) return;
    this.timer = setTimeout(() => {this.show(this.index + 1); schedule();}, delay);
   };
   this.schedule = schedule;
   this.show = (index, manual = false) => {
    this.index = (index + this.slides.length) % this.slides.length;
    this.track.style.transform = 'translateX(-' + (this.index * 100) + '%)';
    this.slides.forEach((slide, i) => {slide.inert = i !== this.index; slide.setAttribute('aria-hidden', String(i !== this.index));});
    this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
    if (manual) {this.querySelector('.eb-mobile-status').textContent = 'Banner ' + (this.index + 1) + ' de ' + this.slides.length; schedule(6000);}
   };
   this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.show(i, true), {signal}));
   this.pause?.addEventListener('click', () => {
    this.stopped = !this.stopped;
    this.pause.textContent = this.stopped ? '▶' : 'Ⅱ';
    this.pause.setAttribute('aria-label', this.stopped ? 'Retomar troca automática' : 'Pausar troca automática'); schedule();
   }, {signal});
   this.addEventListener('pointerdown', e => {clearTimeout(this.timer); this.pointer = {x:e.clientX,y:e.clientY};}, {signal,passive:true});
   this.addEventListener('pointerup', e => {
    if (!this.pointer) return;
    const dx = e.clientX - this.pointer.x, dy = e.clientY - this.pointer.y; this.pointer = null;
    if (Math.abs(dx)>35 && Math.abs(dx)>Math.abs(dy)) {this.show(this.index+(dx<0?1:-1),true);this.suppressClick=true;clearTimeout(this.clickTimer);this.clickTimer=setTimeout(()=>this.suppressClick=false,500);}
    schedule(6000);
   }, {signal,passive:true});
   this.addEventListener('pointercancel',()=>{this.pointer=null;schedule(6000);},{signal});
   this.addEventListener('click',e=>{if(this.suppressClick){e.preventDefault();this.suppressClick=false;}schedule(6000);},{signal,capture:true});
   this.addEventListener('focusin',()=>{this.focused=true;clearTimeout(this.timer);},{signal});
   this.addEventListener('focusout',e=>{if(!this.contains(e.relatedTarget)){this.focused=false;schedule(6000);}},{signal});
   this.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.show(this.index+(e.key==='ArrowRight'?1:-1),true);}},{signal});
   document.addEventListener('visibilitychange',()=>schedule(),{signal});
   this.media.addEventListener('change',()=>schedule(),{signal});
   this.reduced.addEventListener('change',()=>schedule(),{signal});
   this.observer = new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;schedule();},{threshold:.25});this.observer.observe(this);
  }
  disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();clearTimeout(this.timer);clearTimeout(this.clickTimer);}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
